<template>
    <div class='swiperBgSetting'>
        <tab @getTab="getTab"></tab>
        <div id='content' v-if="status === 'content'">
            <div class='headerSerc-item'>
                <span>{{ setTingObj.swiperConfig.title }}</span>
                <swiperConfig :setTingObj="setTingObj"></swiperConfig>
            </div>
        </div>
        <div id='style' v-if="status ==='style'">
            <div class='headerSerc-item'>
                <span>{{setTingObj.bgColor.title}}</span>
                <bgColor :defaultColor="setTingObj.bgColor.default" :color="setTingObj.bgColor.color" @updateBgColorA="updateBgColorA" @updateBgColorB="updateBgColorB"></bgColor>
            </div>
            <div class='headerSerc-item'>
                <span>{{setTingObj.bgStyle.title}} ({{setTingObj.bgStyle.list[setTingObj.bgStyle.type].val}})</span>
                <radio :list="setTingObj.bgStyle.list" :type="setTingObj.bgStyle.type" @change="updateBgStyle"></radio>
            </div>
            <div class='headerSerc-item'>
                <span>{{ setTingObj.lrConfig.title }}</span>
                <sliderAndInput :lrConfig="setTingObj.lrConfig"></sliderAndInput>
            </div>
            <div class='headerSerc-item'>
                <span>{{ setTingObj.mbConfig.title }}</span>
                <sliderAndInput :lrConfig="setTingObj.mbConfig"></sliderAndInput>
            </div>
        </div>
    </div>
</template>

<script>
import tab from '@/components/decoration/common/tab.vue';
import swiperConfig from '@/components/decoration/common/swiperConfig.vue';
import borderRadiusPicker from '@/components/decoration/common/borderRadiusPicker.vue';
import sliderAndInput from '@/components/decoration/common/sliderAndInput.vue';
import bgColor from '@/components/decoration/common/bgColor.vue';
import radio from '@/components/decoration/common/radio.vue';

export default {
    components: {
        radio,
        bgColor,
        borderRadiusPicker,
        tab,
        swiperConfig,
        sliderAndInput
    },
    props: {
        setTingObj: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            status: 'content'
        };
    },
    created() {

    },
    mounted() {

    },
    methods: {
        getTab(e) {
            this.status = e;
        },
        updateBgColorA(e){
            this.setTingObj.bgColor.color[0].item = e
        },
        updateBgColorB(e){
            this.setTingObj.bgColor.color[1].item = e
        },
        updateBgStyle(type){
            this.setTingObj.bgStyle.type = type
        },
    }
};
</script>

<style scoped lang='scss'>
</style>